import { ContactType } from '@rygen/rygen-ui/model';

import { Contact } from './Contact';

export class ClientContact {
  id?: number;
  clientId?: number;
  contact?: Contact;
  contactType?: ContactType;

  constructor(opts?: Partial<ClientContact>) {
    if (opts?.id != null) {
      this.id = opts.id;
    }
    if (opts?.clientId != null) {
      this.clientId = opts.clientId;
    }
    if (opts?.contact != null) {
      this.contact = new Contact(opts.contact);
    }
    if (opts?.contactType != null) {
      this.contactType = opts.contactType;
    }
  }
}
